import { IStep } from "@models/ui-models/step";
import { CompanyStandardStepsEnum } from "../../../models/company/company-registration.model";

export const companyRegistrationSteps: IStep<CompanyStandardStepsEnum>[] = [
    {
      label: 'Declaration',
      step: CompanyStandardStepsEnum.Declaration
    },
    {
      label: 'Company Details',
      step: CompanyStandardStepsEnum.CompanyDetails
    },
    {
      label: 'Address',
      step: CompanyStandardStepsEnum.Address
    },
    {
      label: 'Officeholders',
      step: CompanyStandardStepsEnum.Officeholders
    },
    {
      label: 'Shareholders',
      step: CompanyStandardStepsEnum.Shareholders
    },
    {
      label: 'Authorised Signatories',
      step: CompanyStandardStepsEnum.AuthorisedSignatories
    }
  ]
;
